import { Column } from 'react-table';
import EventStatusCell from './event-table-cells/event-status-cell';
import { DateColumnFilter, SelectColumnFilter } from 'utils/react-table';
import { AppointmentTypeOptions, EventStatusOptions, PublishStatusOptions } from 'common/dto-types/event-dto';
import PublishStatusCell from './event-table-cells/publish-status-cell';
import DateTimeOffsetCell from './event-table-cells/date-time-offset-cell';
import AppointmentTypeCell from './event-table-cells/appointment-type-cell';
import DateTimeCell from './event-table-cells/date-time-cell';

const EventTableColumnConfig: Column[] = [
    {
        Header: 'Id',
        accessor: 'id',
        disableSortBy: false,
    },
    {
        Header: 'Name',
        id: 'name',
        accessor: 'localizedContents.en.name',
        disableSortBy: false,
    },
    {
        Header: 'Starts',
        accessor: 'startDate',
        disableSortBy: false,
        Filter: DateColumnFilter,
        Cell: DateTimeOffsetCell,
    },
    {
        Header: 'Ends',
        accessor: 'endDate',
        disableSortBy: false,
        Filter: DateColumnFilter,
        Cell: DateTimeOffsetCell,
    },
    {
        Header: 'Time Zone',
        accessor: 'timeZone',
        disableSortBy: true,
    },
    {
        Header: 'Venue',
        id: 'venueName',
        accessor: 'venue.name',
        disableSortBy: true,
    },
    {
        Header: 'HostCity',
        accessor: 'hostCity.name',
        disableSortBy: true,
    },
    {
        Header: 'Appointment type',
        accessor: 'appointmentType',
        Cell: AppointmentTypeCell,
        Filter: (props) => <SelectColumnFilter {...props} options={AppointmentTypeOptions} />,
    },
    {
        Header: 'Status',
        accessor: 'eventStatus',
        Filter: (props) => <SelectColumnFilter {...props} options={EventStatusOptions} />,
        Cell: EventStatusCell,
    },
    {
        Header: 'Publish status',
        accessor: 'publishStatus',
        Filter: (props) => <SelectColumnFilter {...props} options={PublishStatusOptions} />,
        Cell: PublishStatusCell,
    },
    {
        Header: 'Modified (UTC)',
        accessor: 'modified',
        disableSortBy: false,
        disableFilters: true,
        Cell: DateTimeCell,
    },
];

export default EventTableColumnConfig;

export const DefaultVisibleEventColumns = [
    'localizedContents.en.name',
    'startDate',
    'endDate',
    'appointmentType',
    'eventStatus',
    'publishStatus',
    'modified',
    'timeZone',
];

export const SearchableEventTableColumnConfig = ['id', 'name', 'appointmentType'];
